/* global angular */

var EmailRssController = function ($scope, $location) {
    "use strict";


    $scope.$watch(function () {
        return $location.search();
    }, function (params) {
        var params1 = $location.search();
       
        var nUrl = "";
        var isSearchPage = window.location.href.indexOf('/search') !== -1;
        for (var idxkey in params1) {
            if (idxkey === "sortBy") {
                // Check if we're on the search page and use the actual value
                if (isSearchPage) {
                    nUrl = nUrl + "&" + "sortBy=" + params1[idxkey];
                } else {
                    nUrl = nUrl + "&" + "sortBy=date";
                }
            }

            if (idxkey === "sortOrder") {
                if (isSearchPage) {
                    nUrl = nUrl + "&" + "sortOrder=" + params1[idxkey];
                } else {
                    nUrl = nUrl + "&" + "sortOrder=desc";
                }
            }

            if (idxkey !== "sortBy" && idxkey !== "sortOrder") {
                var searchKey = params1[idxkey].replace(/&/g, "%26");
                nUrl = nUrl + "&" + idxkey + "=" + searchKey;
            }
        }
                // strip leading &
        if (nUrl.charAt(0) === '&') {
            nUrl = nUrl.substr(1);
        }
        $scope.currentLocation = "?" + nUrl;
    });

    $scope.testvar = 'hello';

};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("EmailRssController", ['$scope', '$location', EmailRssController]);
